const initialState = {
  searchEntry: '',
};

const fieldPaths = (state = initialState, action) => {
  switch (action.type) {
    case 'FIELD_PATHS_CHANGE_SEARCH_ENTRY':
      return {
        ...state,
        searchEntry: action.searchEntry,
      };

    default:
      return state;
  }
};

export default fieldPaths;

export const getSearchEntry = (state) => state.searchEntry;
